import { render, staticRenderFns } from "./majorShowFirst.vue?vue&type=template&id=3b2a2922&scoped=true"
import script from "./majorShowFirst.vue?vue&type=script&lang=ts"
export * from "./majorShowFirst.vue?vue&type=script&lang=ts"
import style0 from "./majorShowFirst.vue?vue&type=style&index=0&id=3b2a2922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a2922",
  null
  
)

export default component.exports